'use strict';

var DeleteUserTokenInterceptorConfig = function DeleteUserTokenInterceptorConfig(RestangularProvider) {
  RestangularProvider.addFullRequestInterceptor(function (headers, params, element) {
    RestangularProvider.setFullResponse(false);
    if (element === 'logout') {
      RestangularProvider.setFullResponse(true);
    }
  });
};
DeleteUserTokenInterceptorConfig.$inject = ['RestangularProvider'];
module.exports = DeleteUserTokenInterceptorConfig;